import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { NbDialogService } from '@nebular/theme';
import { RequestConfirmationDialogComponent } from '../request-confirmation-dialog/request-confirmation-dialog.component';
import { AppLocalStorage } from "../../../../../@core/utils/local-storage.util";

@Component({
    selector: "approval",
    templateUrl: "./approval.component.html",
    styleUrls: ["./approval.component.scss"],
})
export class ApprovalComponent implements OnInit {
    reqForApprovalsData: any;
    employeeID: any;
    selectedCategory: any;
    requestsLoading: boolean;

    @Output() fetchRequest = new EventEmitter<any>();

    constructor(private cdRef: ChangeDetectorRef, private dialogService: NbDialogService,) { }

    @Input()
    set approvalData(value) {
        if (value) {
            this.reqForApprovalsData = value;
            this.cdRef.detectChanges();
        }
    }

    @Input()
    set loadingData(value) {
        // if(value){
        this.requestsLoading = value;
        this.cdRef.detectChanges();
        // }
    }

    ngOnInit(): void {
        const loginEmail = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA");
        this.employeeID = loginEmail.profile.employeeId;
    }


    approveAll(event) {
        const reqBody = {
            category: event.categoryName,
            userId: this.employeeID,
            ticketID: "",
            employeeId: 0,
            fromDate: "",
            toDate: "",
        };

        this.dialogService.open(RequestConfirmationDialogComponent, {
            context: {
                title: 'Are you sure you want to approve all requests?',
                reqData: reqBody,
                action: 'approveAll'
            },
        }).onClose.subscribe((value) => {
            if (value) {
                this.fetchRequest.emit();
            }
        });


    }

    approveRequest(selectedCategory) {
        const me = this;
        this.selectedCategory = selectedCategory;
        this.fetchRequest.emit();
        return;

    }

    declineRequest(selectedCategory) {
        this.selectedCategory = selectedCategory;
        this.fetchRequest.emit();
        return;

    }

}